/**
 * subject-context-search-tree-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { MessageSearchTree } from "../../../search/search-node";
import {
  validateAs,
  validateFor
} from "../../validation/decorators";
import { IncomingMessage } from "../general/";
import { MessageTag } from "../message-tag";

/**
 * The server uses a {@link SubjectContextSearchTreeResponse} to communicate
 * the trees of possible search and filter operations that can be taken to
 * generate a valid query for each type of subject context.
 */
@validateFor(MessageTag.RSP_SUBJECT_CONTEXT_SEARCH_TREE)
export class SubjectContextSearchTreeResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_SUBJECT_CONTEXT_SEARCH_TREE;

  /**
   * The list of valid search *forests* as stratified by subject context type.
   * Each entry can contain multiple trees/roots for that type, which all
   * together form that type's search space.
   */
  @validateAs({array: "object"}) // TODO: much better validation
  public searchTrees : MessageSearchTree[];

  @validateAs(["integer", {min: 0}], true, Number.MAX_SAFE_INTEGER)
  public queryFetchSize : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/search/subject-context-search-tree-response.ts